import { SocialSharing } from '@change/ds-core-ui/next';

import { ICON_VARIANTS } from './costants';
import { useSubComponentsFactory } from './factories/useSubComponentsFactory';
import { PostPreviewStyles } from './PostPreview.styles';
import type { PostPreviewProps } from './types';

export function PostPreview(props: PostPreviewProps) {
	const { variant, size, showPlatformIcon, disabled = false, onClick } = props;
	const mainStyles = PostPreviewStyles({ size, disabled });

	const { header, body, footer } = useSubComponentsFactory(props);
	const iconConfig = ICON_VARIANTS[variant];

	return (
		// eslint-disable-next-line jsx-a11y/click-events-have-key-events
		<section
			data-testid={`post-preview-${variant}`}
			onClick={!disabled ? onClick : undefined}
			className={onClick && !disabled ? 'cursor-pointer' : undefined}
		>
			{/*
				The platform icon is usually shown at the large size, but it is not constrained to that size.
				However, to support other sizes, add the appropriate styles for each size.
			*/}
			{showPlatformIcon && (
				<div className="relative z-10" aria-hidden>
					<div className="border-stroke-inverse-strong bg-background-inverse absolute -right-[15px] -top-[15px] flex h-12 w-12 items-center justify-center overflow-hidden rounded-full border">
						<SocialSharing
							data-testid="platform-icon"
							className="h-12 w-12"
							size="large"
							icon={<iconConfig.icon />}
							aria-hidden
							label=""
							variant={iconConfig.variant}
						/>
					</div>
				</div>
			)}
			<div data-testid="preview-container" className={mainStyles}>
				{header}
				{body}
				{footer}
			</div>
		</section>
	);
}
